export enum PGDASDOperacaoEnum {

  A = "Apuracao",
  R = "Retificacao"
}
